import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./subscription.css";
import Switch from "react-switch";
import { UtilityFunctions } from "../../../utils/UtilityFunctions";
import PaymentProcedure from "./PaymentProcedure";
import { api } from "../../../middleware/api";
import ValidationErrorToast from "../../../components/validationErrorToast";

const SubscriptionModalAccounts = (props: any) => {
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [isPlanSelected, setIsPlanSelected] = useState(null);
  const [isCardAdded, setIsCardAdded] = useState(false);
  const [productId, setProductId] = useState("");
  const [subscriptionStep, setSubscriptionStep] = useState(1);
  const [couponCodeValue, setCouponCodeValue] = useState("");
  const [promoData, setPromoData] = useState<any>();
  const [showSpecialDiscount, setShowSpecialDiscount] = useState(false);
  const [specialDiscountAmount, setSpecialDiscountAmount] = useState<any>();
  const [specialDiscountSource, setSpecialDiscountSource] = useState<any>();

  const [specificPrice, setSpecificPrice] = useState<any>('$1995 + GST');

  const getProductInfoForCode = () => {
    api.get(`subscription/code-detail/?code=${localStorage.getItem("referralCode")}`, {
      "product_id": localStorage.getItem("referralCode"),
    }).then((data) => {
      if (data) {
        setSpecificPrice(data.priceText);
        setProductId(data.productId);

        if (data.saving > 0) {
          setShowSpecialDiscount(true);
          setSpecialDiscountAmount(data.saving);
          setSpecialDiscountSource(data.code);
        }

        setSubscriptionStep(2);
      }
    })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const handlePaymentOption = () => {
    handleCreateSubscription()
  }

  useEffect(() => {
    Promise.all([
      setProductId(window.location.hostname === "localhost" 
          ? 'prod_Rnw3vRstiNbs9H' 
          : 'prod_Rnw6v8MiPgMS0H')
  ]).then(getProductInfoForCode).then(() => {
      setSubscriptionStep(2);
      //handleSubsProduct();
  });

  }, [props.subsModal])

  const handlePayment = () => {
    if (isPlanSelected != null) {
      setIsPaymentOpen(!isPaymentOpen);
    }
    // setIsPlanSelected(null);
  };

  const handleCreateSubscription = () => {
    api.post(`subscription/`, {
      "product_id": productId,
      "promo_code": couponCodeValue
    })
      .then((data) => {
        if (data.data.checkoutUrl && data.data.checkoutUrl !== undefined && data.data.checkoutUrl !== "") {
          window.location.href = data.data.checkoutUrl
        } else {
          ValidationErrorToast("Something went wrong while making payment.", "Payment error");
        }
      })
      .catch((err) => {
        ValidationErrorToast("Something went wrong while making payment.", "Payment error");
      });
  }

  return (
    <>
      <Modal show={props.subsModal} fullscreen={true} className="subs">
          {subscriptionStep === 2 ?
            <div className="sub-2">
              <div className="bg-img  position-relative">
                <div className="row sub-row">
                  <div className="col-md-2 col-auto">
                    <img src={UtilityFunctions.getImageURL() + "logo_White.svg"} />
                  </div>
                  <div className="col-md-8 column-three">
                    <div className="title position-relative">
                      <div className="position-absolute subs-image-container ">
                        <img src="/assets/images/arrow-left.png" className="subs-back-arrow" style={{ width: "24px", color: "white", cursor: "pointer" }} onClick={() => {
                          setPromoData(null)
                          setCouponCodeValue("");
                          setSubscriptionStep(1)
                        }} />
                      </div>Accounts Receivable Subscription
                    </div>
                    <div className="plan">
                      Start collecting cash from outstanding invoices today.
                    </div>
                  </div>
                  <div
                    className="col-md-1 col-7"
                    style={{ justifyContent: "right", display: "flex" }}
                  >
                    {/* <i
                      className="fa fa-times cross"
                      onClick={() => {
                        props.setSubsModal(false);
                        setCouponCodeValue("")
                      }}
                    ></i> */}
                  </div>
                </div>
                <div
                  className="selectedSubscription container-fluid "
                  style={{
                    width: "fit-content",
                    height: "fit-content",
                    padding: "20px",
                  }}
                >
                  <div className="d-flex" style={{ justifyContent: "space-between" }}>
                    <div
                      className="type-box"
                      style={{
                        border: "0.897px solid white",
                        background: "transparent",
                        width: "210px",
                        height: "34px",
                      }}
                    >
                      <div style={{ color: "White" }}>MPLOI Accounts Receivable</div>
                    </div>
                    <div className="d-flex" style={{ alignItems: "center" }}>
                      {/* <input type="radio" checked id="radio" />
                      <div style={{ color: "#FFFFFF", paddingLeft: "5px" }}>{subsPlanData?.price?.recurring?.interval}</div> */}
                    </div>
                  </div>
                  <div
                    className="d-flex main-div"
                  // style={{ justifyContent: "center", paddingLeft: "10px" }}
                  >
                    <div className="col-md-5 col-6 p-0">
                      <div
                        className=" d-flex col-auto mt-3 p-0"
                        style={{
                          justifyContent: "center",
                          alignItems: "baseline",
                          marginLeft: "30px",
                        }}
                      >
                        <div className="price_nav" style={{ textAlign: "inherit" }}>
                          { specificPrice}
                        </div>
                        <div style={{ color: "#FFFFFF" }}>/year</div>
                      </div>
                      <div
                        className="subs-year-text"
                        style={{
                          color: "#FFFFFF",
                          fontSize: "12px",
                          marginTop: "10px",
                        }}
                      >
                      </div>
                    </div>
                    <div className="list-add">
                      <div>
                        <div className="row w-100 list-row mt-1">
                          <div className="col-auto d-flex align-items-center ">
                            <div className="col-auto">
                              <img
                                src="/assets/images/Checkmark.png"
                                className="check"
                              />
                            </div>
                            <div className="col-auto" style={{ paddingLeft: "0px" }}>
                              <div className="list-item">Follow up invoices with AI</div>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                      <div>
                        <div className="row w-100 list-row mt-1">
                          <div className="col-auto d-flex align-items-center">
                            <div className="col-auto">
                              <img
                                src="/assets/images/Checkmark.png"
                                className="check"
                              />
                            </div>
                            <div className="col-auto" style={{ paddingLeft: "0px" }}>
                              <div className="list-item">Personalise your agent</div>
                            </div>
                          </div>
                        </div>
                        <div className="row w-100 list-row mt-1">
                          <div className="col-auto d-flex align-items-center">
                            <div className="col-auto">
                              <img
                                src="/assets/images/Checkmark.png"
                                className="check"
                              />
                            </div>
                            <div className="col-auto" style={{ paddingLeft: "0px" }}>
                              <div className="list-item">Dedicated mobile number</div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div
                    className="hrcard one"
                    style={{ marginLeft: "-15px", width: "244px", position: "absolute", bottom: "0px" }}
                  ></div>
                </div>
                {/* <div className="promoCode">
                  <div className="d-flex" style={{ alignItems: "center" }}>
                    <input
                      type="text"
                      placeholder="Type coupon code here"
                      className="promo-code"
                      value={couponCodeValue}
                      onChange={(e) => setCouponCodeValue(e.target.value)}
                    />
                    {!promoData &&
                      <div
                        style={{
                          color: "#06EFC5",
                          fontSize: "16px",
                          paddingLeft: "20px",
                          cursor: "pointer"
                        }}
                        onClick={() => handleCouponCode()}
                      >
                        Apply
                      </div>
                    }
                    {promoData &&
                      <div
                        style={{
                          color: "#06EFC5",
                          fontSize: "16px",
                          paddingLeft: "20px",
                          cursor: "pointer"
                        }}
                        onClick={() => {
                          setPromoData(null)
                          setCouponCodeValue("");
                        }}
                      >
                        Remove Coupon
                      </div>
                    }
                  </div>
                  <div
                    style={{ color: "white", paddingTop: "10px", fontSize: "10px" }}
                  >
                    Note: Promo code will be applied only once
                  </div>
                </div> */}
                <div className="container-fluid margn-top38">
                  <div
                    className="navSubscription container-fluid"
                    style={{ width: "409px" }}
                  >
                    <div className="heading">Price Details</div>
                    <div style={{ padding: "10px 10px" }}>
                      <div className="price-details">
                        <div className="price-details-text">
                          MPLOI Accounts Receivable Yearly
                        </div>
                        <div className="price-details-text">$1995 + GST</div>
                      </div>
                      {showSpecialDiscount && specialDiscountAmount && specialDiscountSource && (
                        <div className="price-details">
                          <div className="price-details-text">
                            Special Discount
                          </div>
                          <div className="price-details-text" style={{ color: "#06EFC5" }}>
                            -${specialDiscountAmount} courtesy of {specialDiscountSource}
                          </div>
                        </div>
                      )}
                      <div className="price-details">
                        <div
                          className="price-details-text"
                          style={{ fontWeight: "500" }}
                        >
                          Pay
                        </div>
                        <div
                          className="price-details-text"
                          style={{ fontWeight: "500" }}
                        >
                          { specificPrice }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="mt-4"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div>
                      <div className="d-flex" style={{ width: "fit-content", margin: "0px auto", alignItems: "center" }}>
                        {promoData && <>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8.74905 5.50003C8.74905 5.91371 8.41369 6.24907 8.00001 6.24907C7.58633 6.24907 7.25098 5.91371 7.25098 5.50003C7.25098 5.08635 7.58633 4.751 8.00001 4.751C8.41369 4.751 8.74905 5.08635 8.74905 5.50003ZM8 7C8.27614 7 8.5 7.22386 8.5 7.5V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V7.5C7.5 7.22386 7.72386 7 8 7Z"
                              fill="#06EFC5"
                            />
                          </svg>

                          <div style={{ color: "#06EFC5", fontSize: "12px", paddingLeft: "5px" }}>
                            You are saving ${promoData?.price?.discountAmount}.
                          </div>
                        </>
                        }
                      </div>

                      <div className="btn-continue mt-1" style={{ width: "350px" }} onClick={() => handlePaymentOption()} >
                        <div className="cont " >Pay { specificPrice }</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            : ""}
        {isPaymentOpen ?
          <div style={{ width: "100vw", height: "100%" }} className=" container-fluid position-absolute outer_container" onClick={() => handlePayment()}>
            <div className=" d-flex align-items-center justify-content-center" style={{ width: "100vw", height: "100vh" }}>
              <PaymentProcedure
                isCardAdded={isCardAdded}
                productId={productId}
                couponCodeValue={couponCodeValue}
              />
            </div>
          </div>
          :
          null}
      </Modal >
    </>
  );
};

export default SubscriptionModalAccounts;
